import { render } from "./CoverageList.vue?vue&type=template&id=383ead02"
import script from "./CoverageList.vue?vue&type=script&lang=js"
export * from "./CoverageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__